import React from 'react';

interface PartnerAdAccountLinkProps {
  id: string;
  name: string;
  count: number;
  href: string;
}

export const PartnerAdAccountLink: React.FC<PartnerAdAccountLinkProps> = ({ id, href, count, name }) => {
  const imgPath = `assets/images/account-${id}.svg`;
  const imgMonoPath = `assets/images/account-${id}.mono.svg`;

  return (
    <a href={href} className="partner-ad-account" title={t(name)}>
      <div className="partner-ad-account__icon">
        <img src={imgMonoPath} alt="" />
        <img src={imgPath} alt="" className="alt" />
      </div>
      <div className="partner-ad-account__count">{count}</div>
    </a>
  );
};
